export default __webpack_public_path__ + "static/media/DE.eedbc5f3.png";